import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Observable, of ,from, throwError} from "rxjs";
import { mergeMap, catchError } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { TokenService } from "../authentication/token.service";
import { SettingsService } from "../../core/bootstrap/settings.service";
import { environment } from "../../../environments/environment";
import { AuthService } from "../../shared/services/auth.service";
import { UserContextPoolService } from "../bootstrap/user-context-pool.service.";
@Injectable()
export class DefaultInterceptor implements HttpInterceptor {
    constructor(
        private readonly router: Router,
        private readonly toastr: ToastrService,
        private readonly token: TokenService,
        private readonly settings: SettingsService,
        private readonly auth: AuthService,
        private readonly userContextPool:UserContextPoolService,
        private readonly ngZone: NgZone
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Convert the Promise (getTokens) into an Observable using from()
        return from(this.auth.getUserTokens()).pipe(
            mergeMap((data: any) => {
                
                const userRole = data.UserRoleName;
                const token = data.token;

                const bearerToken = `Bearer ${token}`;
                const url = environment.SERVER_ORIGIN + req.url;
                 const userpoolid= this.userContextPool.getUserPoolId();
                 const userregion = this.userContextPool.getUserRegion();
            

                const headers: any = {
                     "poolid":userpoolid,
                     "region":userregion,
                    Accept: 'application/json',
                    'Accept-Language': this.settings.language,
                    Authorization: bearerToken,
                };

                if (userRole) {
                    headers['X-Custom-Header'] = userRole;
                }

                const newReq = req.clone({
                    url,
                    setHeaders: headers,
                    withCredentials: true,
                });

                // Ensure all emissions from HttpClient are forwarded inside Angular's zone
                return new Observable<HttpEvent<any>>(observer => {
                    const sub = next.handle(newReq).subscribe({
                        next: (event: HttpEvent<any>) => {
                            this.ngZone.run(() => {
                                if (event instanceof HttpResponse) {
                                    const body: any = event.body;
                                    if (body?.msg && body.msg !== "") {
                                        this.toastr.error(body.msg);
                                    }
                                }
                                observer.next(event);
                            });
                        },
                        error: (error: HttpErrorResponse) => {
                            this.ngZone.run(() => {
                                switch (error.status) {
                                    case 401:
                                        console.log(error, "error at interceptor");
                                        this.goto(`/auth/login`);
                                        this.toastr.error("You dont have permission to access this page");
                                        break;
                                    default:
                                        if (!(error instanceof HttpErrorResponse)) {
                                            observer.error(new Error('Unexpected error type'));
                                            return;
                                        }
                                        break;
                                }
                                observer.error(error);
                            });
                        },
                        complete: () => this.ngZone.run(() => observer.complete())
                    });

                    return () => sub.unsubscribe();
                });
            })
        );
    }

   

    private goto(url: string) {
        setTimeout(() => this.router.navigateByUrl(url));
    }

    /**
     * successfull api handler
     * @param event event
     */
    private handleOkReq(event: HttpEvent<any>): Observable<any> {
        if (event instanceof HttpResponse) {
            const body: any = event.body;
            if (body?.msg && body.msg !== "") {
                this.toastr.error(body.msg);
            }

            return of(event);
        }

        return of(event);
    }

    /**
     * error api handler
     * @param error error
     */
    private handleErrorReq(error: HttpErrorResponse): Observable<never> {
        switch (error.status) {
            case 401:
                console.log(error, "eror at intercepto");
                this.goto(`/auth/login`);
                this.toastr.error("You dont have permission to access this page");
                break;
            // case 403:
            // case 404:
            // case 500:
            //     this.goto(`/sessions/${error.status}`);
            //     break;
            default:
                if (!(error instanceof HttpErrorResponse)) {
                    throw new Error('Unexpected error type');
                }
                break;
        }
       return throwError(() => error);

    }
}
